// Backend ResponseId values returned by UserSSOSignIn / CustomSignIn
export const LOGIN_STATUS = {
  SUCCESS: 1,
  INACTIVE: 2,
  DELETED: 3,
  NO_ROLE: 4,
  DIFFERENT_METHOD: 6,
};

// Centralised user-facing messages for all login methods
export const LOGIN_MESSAGES = {
  // Default (email + password)
  INVALID_CREDENTIALS: "Invalid credentials. Please check your email and password.",

  // Common account-state errors
  ACCOUNT_INACTIVE: "Your account is inactive. Please contact the administrator.",
  ACCOUNT_DELETED: "Your account has been deleted. Please contact the administrator.",
  ROLE_NOT_DEFINED: "Your role has not been defined. Please contact the administrator.",
  NO_ROLE_ASSIGNED: "Your account has been created but no role has been assigned. Please contact the administrator.",

  // Microsoft SSO (Entra ID)
  SSO_FAILED: "SSO login failed. Please try again.",

  // Okta
  OKTA_FAILED: "Okta login failed. Please try again.",
  OKTA_AUTH_FAILED: "Okta authentication failed. Please try again.",
  OKTA_AUTH_FAILED_PREFIX: "Okta authentication failed: ",

  // SAML
  SAML_NO_REDIRECT: "No redirect URL returned from SAML challenge.",
  SAML_INIT_FAILED: "Could not initiate SAML sign-in. Please try again.",
  SAML_MISSING_PAYLOAD: "SAML callback is missing the login payload.",
  SAML_NO_TOKEN: "SAML login did not return an authentication token.",
  SAML_PARSE_FAILED: "Could not parse the SAML login response. Please try again.",

  // Google
  GOOGLE_FAILED: "Google login failed. Please try again.",
  GOOGLE_AUTH_FAILED: "Google authentication failed. Please try again.",
  GOOGLE_AUTH_FAILED_PREFIX: "Google authentication failed: ",
  GOOGLE_NOT_CONFIGURED: "Google sign-in is not configured. Please contact the administrator.",
  GOOGLE_NO_TOKEN: "Google login did not return an authentication token.",
  GOOGLE_STATE_MISMATCH: "Google sign-in could not be verified. Please try again.",

  // MFA
  MFA_FAILED: "MFA verification failed",

  // Wrong login method (all SSO types)
  DIFFERENT_METHOD: "This email is registered with a different login method. Please use the correct sign-in option.",

  // Callback UI text
  OKTA_VERIFYING: "Verifying your identity",
  OKTA_VERIFYING_SUBTITLE: "This will only take a moment",
  SAML_VERIFYING: "Completing SAML sign-in...",
  GOOGLE_VERIFYING: "Completing Google sign-in...",

  // Generic fallback
  LOGIN_FAILED_GENERIC: "Login failed. Please try again.",

  // Forgot Password
  FORGOT_PASSWORD_EMAIL_REQUIRED: "Email is required.",
  FORGOT_PASSWORD_INVALID_EMAIL: "Please enter a valid email address.",
  FORGOT_PASSWORD_USER_NOT_FOUND: "The email address is not authorized.",
  FORGOT_PASSWORD_FAILURE_GENERIC: "Something went wrong. Please try again.",
  FORGOT_PASSWORD_SUCCESS: "A password reset link has been sent to your email.",

  // Reset Password
  RESET_PASSWORD_REQUIRED: "Password is required.",
  RESET_PASSWORD_COMPLEXITY: "Must be at least 8 characters with letters and numbers.",
  RESET_PASSWORD_CONFIRM_REQUIRED: "Please confirm your password.",
  RESET_PASSWORD_MISMATCH: "Password does not match.",
  RESET_PASSWORD_SUCCESS: "Your password has been reset successfully.",
  RESET_PASSWORD_INVALID_LINK: "This reset link is invalid or has expired.",
  RESET_PASSWORD_FAILURE_GENERIC: "Unable to reset your password. Please try again.",
};


export const LOGIN_SOURCES = {
  GOOGLE: "GOOGLE",
  MICROSOFT_ENTRAID: "MICROSOFT_ENTRAID"
}